import type { ModelError } from "@iot-platform/core";
import { NonRecuperableModelError } from "@iot-platform/core";
import type { ReportStatesGpsDto } from "@report/data/dto/report-states-gps.dto.ts";
import { ReportStatesGpsDtoSchema } from "@report/data/dto/report-states-gps.dto.ts";
import { Report } from "@report/domain/models/report.model";
import { injectable } from "inversify";
import { err, ok, Result } from "neverthrow";

@injectable()
export class ReportStateGpsMapper {
    map(
        reportStatesGpsDto: ReportStatesGpsDto,
    ): Result<Report[], ModelError<typeof Report>> {
        const reportStatesGpsParsed =
            ReportStatesGpsDtoSchema.safeParse(reportStatesGpsDto);

        if (!reportStatesGpsParsed.success) {
            console.error(reportStatesGpsParsed.error.issues);
            return err(new NonRecuperableModelError());
        }

        const reportsResults = Object.values(reportStatesGpsDto.data).map(
            (report) => {
                const station = report.station;
                const reportData = report.data;
                const reportPagination = report.pagination;
                const reportMapped = [];

                if (reportData.DESPLAZAMIENTO) {
                    reportMapped.push({
                        status: "DESPLAZAMIENTO",
                        hour: reportData.DESPLAZAMIENTO.time,
                        traveledKilometers:
                            reportData.DESPLAZAMIENTO.traveled_kilometers,
                    });
                }

                if (reportData.PARADA) {
                    reportMapped.push({
                        status: "PARADA",
                        hour: reportData.PARADA.time,
                        traveledKilometers:
                            reportData.PARADA.traveled_kilometers,
                    });
                }

                reportMapped.push({
                    hour: reportData.totals.time,
                    traveledKilometers: reportData.totals.traveled_kilometers,
                });

                return Report.createWithRecovery({
                    stationReportSummary: {
                        icon: station.icon,
                        stationId: station.id,
                        stationName: `${station.name} (${station.technical_name})`,
                    },
                    items: reportMapped,
                    pagination: {
                        count: reportPagination.count,
                        current: reportPagination.current,
                        pages: reportPagination.pages,
                        perPage: reportPagination.per_page,
                    },
                });
            },
        );

        if (reportsResults.some((result) => result.isErr())) {
            return err(new NonRecuperableModelError());
        }

        return ok(
            reportsResults
                .map((result) => result.unwrapOr(null))
                .filter(Boolean),
        );
    }
}
